const Weight = ({ handleHubChange }) => {
  return (
    <button
      className='bg-secondary rounded-xl p-4'
      onClick={() => handleHubChange('WEIGHT_PROGRESS')}
    >
      <div className='flex items-center gap-4 mb-4'>
        <h2 className='text-lg font-semibold'>Weight Log</h2>
      </div>
      <p className='text-sm text-gray-400 mb-4 text-left'>
        Record weight progress
      </p>
    </button>
  );
};

export default Weight;
